import http from '@/utils/services/http'

export function list (limit, page, filtros) {
  return http.get('/api/patio/?page=' + page + '&limit=' + limit + filtros)
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(({response}) => {
      return Promise.reject(response)
    })
}

export default {
  list (limit, page, filtros) {
    return http.get('/api/patio/?page=' + page + '&limit=' + limit + filtros)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  cadastrar (data, id) {
    if (id) {
      return this.update(data, id)
    }
    return http.post('/api/patio/new', JSON.stringify(data))
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  find (id) {
    id = parseInt(id)
    if (id < 1) return Promise.reject()
    return http.get('/api/patio/' + id)
      .then(response => {
        console.log(response)
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  update (data, id) {
    return http.patch('/api/patio/' + id + '/update', JSON.stringify(data))
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  },
  deletar (id) {
    return http.delete('/api/patio/' + id)
      .then(response => {
        return Promise.resolve(response)
      })
      .catch(({response}) => {
        return Promise.reject(response)
      })
  }
}



// WEBPACK FOOTER //
// ./src/domain/patio/services/patio.js